export default __webpack_public_path__ + "static/media/mmhg-gray.574389ff.svg";